import React from 'react';
import './GestaoReembolsosSkeleton.css';

const Bone = ({ w, h = 10, r = 6, className = '' }) => (
  <span className={`gr-sk-bone ${className}`} style={{ width: w, height: h, borderRadius: r }} />
);

const COORDS = [
  { techs: 2, w: 560 },
  { techs: 1, w: 300 },
  { techs: 3, w: 830 },
];

function OverviewSkeleton() {
  return (
    <div className="gr-sk-coord-list">
      {COORDS.map((c, i) => (
        <div key={i} className="gr-sk-coord" style={{ flexBasis: c.w }}>
          <div className="gr-sk-coord-head">
            <Bone w={34} h={34} r={999} />
            <div className="gr-sk-col">
              <Bone w="46%" h={11} />
              <div className="gr-sk-row">
                <Bone w={70} h={9} />
                <Bone w={84} h={9} />
              </div>
            </div>
          </div>
          <div className="gr-sk-area-head">
            <Bone w={8} h={8} r={999} />
            <Bone w={90} h={9} />
            <Bone w={56} h={9} className="gr-sk-push" />
          </div>
          <div className="gr-sk-tech-grid">
            {Array.from({ length: c.techs }).map((_, j) => (
              <div key={j} className="gr-sk-tech">
                <div className="gr-sk-row">
                  <Bone w={28} h={28} r={999} />
                  <div className="gr-sk-col">
                    <Bone w="70%" h={10} />
                    <Bone w="40%" h={8} />
                  </div>
                </div>
                <Bone w="100%" h={6} r={999} />
                <div className="gr-sk-row gr-sk-between">
                  <Bone w={64} h={9} />
                  <Bone w={48} h={9} />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

function DetailSkeleton() {
  return (
    <div className="gr-sk-detail">
      <div className="gr-sk-row gr-sk-detail-top">
        <Bone w={40} h={40} r={999} />
        <div className="gr-sk-col">
          <div className="gr-sk-row">
            <Bone w={140} h={14} />
            <Bone w={96} h={16} r={999} />
          </div>
          <Bone w={180} h={9} />
        </div>
      </div>
      <div className="gr-sk-row gr-sk-tabs">
        {[56, 78, 74, 76, 72].map((w, i) => (
          <Bone key={i} w={w} h={22} r={8} />
        ))}
        <Bone w={120} h={22} r={8} className="gr-sk-push" />
      </div>
      <div className="gr-sk-table">
        <div className="gr-sk-thead">
          {[14, 60, 44, 52, 120, 70, 60, 80].map((w, i) => (
            <Bone key={i} w={w} h={8} />
          ))}
        </div>
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="gr-sk-tr">
            <Bone w={14} h={14} r={4} />
            <Bone w={58} h={9} />
            <Bone w={44} h={9} />
            <Bone w={52} h={9} />
            <Bone w={`${38 + ((i * 17) % 40)}%`} h={9} />
            <Bone w={64} h={9} />
            <Bone w={56} h={9} />
            <Bone w={78} h={18} r={999} />
          </div>
        ))}
      </div>
    </div>
  );
}

/**
 * Skeleton de carregamento da Gestão de reembolsos.
 * `withToolbar`: desenha a barra de filtros (carga inicial, quando a barra real ainda não existe).
 */
export default function GestaoReembolsosSkeleton({ variant = 'overview', withToolbar = false, overlay = false }) {
  return (
    <div
      className={`gr-sk${overlay ? ' gr-sk--overlay' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Carregando reembolsos"
    >
      {withToolbar ? (
        <div className="gr-sk-toolbar">
          {[92, 60, 70].map((w, i) => (
            <Bone key={`a${i}`} w={w} h={24} r={8} />
          ))}
          <span className="gr-sk-sep" />
          {[78, 64, 120, 128].map((w, i) => (
            <Bone key={`b${i}`} w={w} h={24} r={8} />
          ))}
          <Bone w={82} h={24} r={8} className="gr-sk-push" />
          <Bone w={108} h={24} r={8} />
        </div>
      ) : null}
      {variant === 'detail' ? <DetailSkeleton /> : <OverviewSkeleton />}
    </div>
  );
}
